/**
 * This file is auto-generated by scripts/generate-blog-data.js
 * Do not edit this file directly
 */

export interface BlogPostMetadata {
  slug: string;
  title: string;
  date: string;
  author: string;
  excerpt: string;
  tags: string[];
  image: string;
  contentPath: string;
  unsplashQuery?: string; // Optional query for Unsplash
}

export interface BlogPost extends BlogPostMetadata {
  content: string;
}

export const blogPostsMetadata: BlogPostMetadata[] = [
  {
    "slug": "frontend-frameworks-comparison-2025",
    "title": "Frontend Frameworks Comparison 2025: React vs. Vue vs. Angular vs. Svelte",
    "date": "2025-03-10",
    "author": "David Sheeshka",
    "excerpt": "A comprehensive analysis of the top frontend frameworks in 2025, comparing performance metrics, developer experience, and market adoption with detailed visualizations.",
    "tags": [
      "JavaScript",
      "Web Development",
      "Frontend",
      "Frameworks",
      "React",
      "Vue",
      "Angular",
      "Svelte"
    ],
    "image": "/images/blog-fallback-1.jpg",
    "contentPath": "/blog-content/frontend-frameworks-comparison-2025.md"
  },
  {
    "slug": "llm-comparison-guide-2025",
    "title": "The Ultimate Guide to Large Language Models in 2025: Comprehensive Comparison",
    "date": "2025-03-10",
    "author": "David Sheeshka",
    "excerpt": "An in-depth comparison of leading LLMs in 2025, analyzing their capabilities, performance metrics, use cases, and limitations to help you choose the right model for your AI applications.",
    "tags": [
      "artificial intelligence",
      "LLMs",
      "machine learning",
      "GPT-5",
      "Claude 3",
      "Llama 3",
      "Mistral",
      "Gemini Ultra"
    ],
    "image": "/images/default-blog-image.jpg",
    "contentPath": "/blog-content/llm-comparison-guide-2025.md"
  },
  {
    "slug": "react-state-management-2025",
    "title": "Modern React State Management in 2025",
    "date": "2025-03-10",
    "author": "David Sheeshka",
    "excerpt": "Discover the latest approaches to state management in React applications and how they can improve your development workflow.",
    "tags": [
      "React",
      "JavaScript",
      "Web Development",
      "State Management"
    ],
    "image": "", // Empty string to force using Unsplash
    "unsplashQuery": "react state management code programming", // Specific query for better results
    "contentPath": "/blog-content/react-state-management-2025.md"
  },
  {
    "slug": "web-development-trends-2025",
    "title": "Web Development Trends in 2025",
    "date": "2025-03-09",
    "author": "David Sheeshka",
    "excerpt": "Explore the latest web development trends that are shaping the industry in 2025",
    "tags": [
      "Web Development",
      "Technology",
      "Trends"
    ],
    "image": "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1472&q=80",
    "contentPath": "/blog-content/web-development-trends-2025.md"
  },
  {
    "slug": "ai-in-web-development",
    "title": "The Impact of AI on Web Development in 2025",
    "date": "2025-03-08",
    "author": "David Sheeshka",
    "excerpt": "Discover how artificial intelligence is transforming the web development process, from code generation to testing and optimization.",
    "tags": [
      "AI",
      "Web Development",
      "Technology",
      "Future"
    ],
    "image": "/images/blog-fallback-2.jpg",
    "contentPath": "/blog-content/ai-in-web-development.md"
  },
  {
    "slug": "typescript-best-practices",
    "title": "TypeScript Best Practices for Modern Web Applications",
    "date": "2025-03-07",
    "author": "David Sheeshka",
    "excerpt": "Learn the most effective TypeScript patterns and practices that will help you build more robust and maintainable web applications.",
    "tags": [
      "TypeScript",
      "JavaScript",
      "Web Development",
      "Best Practices"
    ],
    "image": "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
    "contentPath": "/blog-content/typescript-best-practices.md"
  },
  {
    "slug": "serverless-architecture",
    "title": "Serverless Architecture: The Future of Web Development",
    "date": "2025-03-06",
    "author": "David Sheeshka",
    "excerpt": "Explore how serverless architecture is transforming web development, reducing costs, and enabling developers to focus on code rather than infrastructure.",
    "tags": [
      "Serverless",
      "Cloud Computing",
      "Web Development",
      "Architecture"
    ],
    "image": "/images/blog-fallback-3.jpg",
    "contentPath": "/blog-content/serverless-architecture.md"
  }
];

// This array is just for reference, actual content should be loaded dynamically via fetch
export const getBlogPostContent = async (slug: string): Promise<string> => {
  try {
    const post = blogPostsMetadata.find(post => post.slug === slug);
    if (!post || !post.contentPath) {
      throw new Error(`Blog post with slug ${slug} not found`);
    }
    
    // Use absolute URL with origin for fetch
    const baseUrl = window.location.origin;
    // Remove leading slash if present to avoid double slashes
    const cleanPath = post.contentPath.startsWith('/') ? post.contentPath.substring(1) : post.contentPath;
    const fullPath = `${baseUrl}/${cleanPath}`;
    
    console.log(`Fetching blog content from: ${fullPath}`);
    
    const response = await fetch(fullPath);
    if (!response.ok) {
      console.error(`Failed to fetch blog post content from ${fullPath}: ${response.status} ${response.statusText}`);
      
      // Try an alternative path as fallback
      const altPath = `${baseUrl}/blog-content/${slug}.md`;
      console.log(`Trying alternative path: ${altPath}`);
      
      const altResponse = await fetch(altPath);
      if (!altResponse.ok) {
        throw new Error(`Failed to fetch blog post content from both paths`);
      }
      
      const rawMarkdown = await altResponse.text();
      console.log(`Successfully loaded content from alternative path for ${slug}, length: ${rawMarkdown.length} characters`);
      return rawMarkdown;
    }
    
    const rawMarkdown = await response.text();
    console.log(`Successfully loaded content for ${slug}, length: ${rawMarkdown.length} characters`);
    return rawMarkdown;
  } catch (error) {
    console.error(`Error loading blog post content: ${error}`);
    return '# Error Loading Content\n\nSorry, we couldn\'t load the content for this blog post. Please try again later.';
  }
};
